module.exports = __webpack_public_path__ + "static/sydney-profile-06bd011cc7858abfdfe6888a6a87f8a6.png";